import './polyfills';

// eslint-disable-next-line no-unused-expressions
import('./standalone-bootstrap');
